import { render, staticRenderFns } from "./SortArrows.vue?vue&type=template&id=2f1ed168&scoped=true&"
import script from "./SortArrows.vue?vue&type=script&lang=js&"
export * from "./SortArrows.vue?vue&type=script&lang=js&"
import style0 from "./SortArrows.vue?vue&type=style&index=0&id=2f1ed168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ed168",
  null
  
)

export default component.exports